import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import Header from './Component/Header';
import Footer from './Component/Footer';
import WhatsAppWidget from './Component/WhatsAppWidget';
import CookieConsent from './Component/Cookies';



const App = () => {
  return (
    <Router>
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="*" element={<NotFound />} />
  
      </Routes>
      <WhatsAppWidget />
      <CookieConsent/>

      <Footer />
    </Router>
  );
};

export default App;